export default "__VITE_ASSET__BOoqPZTm__"